export enum ControlPosition {
    TOP = 'top',
    BOTTOM = 'bottom',
    NONE = 'none',
}